import { NavigationItem } from '../types';

// Navigation constants used throughout the app
export const DEFAULT_NAVIGATION_ITEMS: NavigationItem[] = [
  { title: "Home", href: "#/" },
  { title: "Services", href: "#/services" },
  { title: "About", href: "#/about" },
  { title: "Contact", href: "#/contact" }
];
